<template>
    <div class="flex items-center">
        <!-- Checkbox Input -->
        <input type="checkbox" :id="field.id" class="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            :checked="modelValue" @change="$emit('update:modelValue', $event.target.checked)" />

        <!-- Label with Required Indicator -->
        <label :for="field.id" class="ml-2 text-sm font-medium text-gray-700">
            {{ field.label }}
            <span v-if="field.required" class="text-red-500">*</span>
        </label>
    </div>

    <!-- Field Description -->
    <p v-if="field.description" class="text-xs text-gray-500 mt-1">
        {{ field.description }}
    </p>

</template>


<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Boolean, // Ensure it's a Boolean
            default: false,
        },
        errorMessage: {
            type: String, // Error message for the field
            default: '',
        }
    }
};
</script>
